"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RequestType;
(function (RequestType) {
    RequestType[RequestType["APPROVE"] = 0] = "APPROVE";
    RequestType[RequestType["DISPUTE"] = 1] = "DISPUTE";
    RequestType[RequestType["REASSIGNDIVISION"] = 2] = "REASSIGNDIVISION";
    RequestType[RequestType["PAY"] = 3] = "PAY";
    RequestType[RequestType["ENTERGLCODES"] = 4] = "ENTERGLCODES";
    RequestType[RequestType["VIEWGLCODES"] = 5] = "VIEWGLCODES";
    RequestType[RequestType["EDITGLCODES"] = 6] = "EDITGLCODES";
    RequestType[RequestType["CREATEUSER"] = 7] = "CREATEUSER";
    RequestType[RequestType["MANAGEUSER"] = 8] = "MANAGEUSER";
})(RequestType = exports.RequestType || (exports.RequestType = {}));
//# sourceMappingURL=RequestType.js.map